// import React, { useEffect, useRef, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   InsertRegisterNotifier,
//   RegisterRefIframe,
//   RemoveNotifier,
//   ShowInfoDisplay,
//   AlterScreen,
//   startInteractions,
//   changeAtdIngDesk,
//   ShowVisibleNextAtd,
//   addInteractionIngDesk,
//   isSaveInteractionIngDesk,
//   isSaveClientIdInteraction,
//   removeInteractionIngDesk,
//   changeTokenIngDeskEndPoint,
//   getmiddlewarecrm,
//   insertProtocolCRM,
//   changeAtdIngDeskSuccess,
//   addMessageHeader,
//   changeActiveHeader,
//   editPermissionsIngdesk,
//   startInteractionsFromClientWallet,
//   SolicitarChamadaAtiva,
// } from "../actions";
// import Moment from "moment";
// import { connection_platform } from "../services/api";

// let count = 0;
// let channelId = 5;
// let loginIngDesk = false;
// let url_iframe = "";
// let idMiddleware = "";
// // let caseId = 0;

// const IngDesk = () => {
//   const iframeRef = useRef(null);
//   const dispatch = useDispatch();
//   const [sendMessage, setSendMessage] = useState(false);
//   const [isSendMe, setIsSendMe] = useState(false);
//   const [caseId, setCaseId] = useState(0);
//   const [idMiddleState, setIdMiddlestate] = useState(false);
//   const user = useSelector((state) => state.informationusers);
//   const interaction = useSelector((state) => state.atendimento);
//   const screen = useSelector((state) => state.infodisplay);
//   const interactioningdesk = useSelector((state) => state.interactioningdesk);
//   const connectionsapi = useSelector((state) => state.connectionsapi);
//   const serviceurl = useSelector((state) => state.serviceurl);
//   const activeheader = useSelector((state) => state.activeheader);
//   // const routergroups = useSelector((state) => state.routergroups);

//   if (serviceurl.length !== 0) {
//     let ArrayServiceURL = "";
//     if (user.nameauth === "IngDesk") {
//       ArrayServiceURL = serviceurl.filter((url) => url.typeofcrm === "IngDesk");
//       if (ArrayServiceURL.length !== 0) {
//         url_iframe = ArrayServiceURL[0].param;
//       }
//     }
//   }

//   async function getIdMiddleware() {
//     idMiddleware = await getmiddlewarecrm();
//     setIdMiddlestate(true);
//   }

//   // url_iframe = "http://localhost:3000";

//   useEffect(() => {
//     window.addEventListener("message", (message) => {
//       if (message.data.origin !== "ingdesk") return;

//       const { id, payload } = message.data;

//       if (id === "remindersDeleted") {
//         payload.map((todo) => {
//           //console.debug("(INGWEB) remindersDeleted - todo: ", todo);
//           dispatch(RemoveNotifier(todo.id_tarefas_lembrete));
//         });
//       }

//       if (id === "tasksOverdueDeleted") {
//         payload.map((todo) => {
//           //console.debug("(INGWEB) tasksOverdueDeleted - todo: ", todo);
//           dispatch(RemoveNotifier(todo.idTask));
//         });
//       }

//       if (id === "reminders") {
//         let data = Moment();
//         payload.map((todo) => {
//           // console.debug("(INGWEB) reminders - todo: ", todo);
//           dispatch(
//             InsertRegisterNotifier(
//               [todo.description[0]],
//               "mensagemingdesk",
//               data,
//               "IngDesk",
//               todo.mensagem,
//               "1",
//               todo.idReminder, // notification id
//               todo.idReminder,
//               todo,
//             ),
//           );
//           count++;
//         });
//       }

//       if (id === "tasksOverdue") {
//         let data = Moment();
//         payload.map((todo) => {
//           //console.debug("(INGWEB) tasksOverdue - todo: ", todo);
//           dispatch(
//             InsertRegisterNotifier(
//               [todo.description[0]],
//               "mensagemingdesk",
//               data,
//               "IngDesk",
//               todo.mensagem,
//               "1",
//               todo.idTask, // notification id
//               todo.idTask,
//               todo,
//             ),
//           );
//           count++;
//         });
//       }

//       if (id === "caseReminders") {
//         let data = Moment();
//         payload.map((todo) => {
//           // console.debug("(INGWEB) reminders - todo: ", todo);
//           dispatch(
//             InsertRegisterNotifier(
//               [todo.description[0]],
//               "mensagemingdesk",
//               data,
//               "IngDesk",
//               todo.mensagem,
//               "1",
//               todo.idAlert, // notification id
//               todo.idCase,
//               todo,
//             ),
//           );
//           count++;
//         });
//       }

//       if (id === "startInteraction") {
//         dispatch(
//           startInteractions(payload.channelId, payload.destination, payload),
//         );
//         channelId = payload.channelId;
//       }

//       if (id === "startInteractionFromClientWallet") {
//         // dispatch(
//         //   startInteractionsFromClientWallet(
//         //     payload.channelId,
//         //     payload.destination,
//         //     payload
//         //   )
//         // );

//         dispatch(
//           SolicitarChamadaAtiva(
//             // routergroups,
//             payload.channelId,
//             payload.destination,
//           ),
//         );

//         channelId = payload.channelId;
//       }

//       if (id === "willLogInteraction") {
//         dispatch(
//           addInteractionIngDesk({
//             ...payload,
//             caseId: payload.caseId,
//             isSendLog: true,
//           }),
//         );
//       }

//       if (id === "saveThisInteraction") {
//         dispatch(
//           isSaveInteractionIngDesk({ caseId: payload.caseId, isSendLog: true }),
//         );
//         dispatch(addMessageHeader(payload.destination, payload.infos));
//         if (payload.destination) {
//           let findChecked = activeheader.find(
//             (header) => header.label === payload.destination,
//           );

//           if (!findChecked) {
//             let storage = JSON.parse(
//               window.localStorage.getItem("switchHeader"),
//             );
//             dispatch(
//               changeActiveHeader(
//                 payload.destination,
//                 typeof storage === "boolean" ? storage : false,
//               ),
//             );
//           }
//         }
//         setSendMessage(true);
//       }

//       if (id === "deliveryContactIdInteraction") {
//         dispatch(isSaveClientIdInteraction(payload));
//       }

//       if (id === "sendMeLogInteraction") {
//         setCaseId(payload.caseId);
//         setIsSendMe(true);
//         dispatch(changeAtdIngDesk(payload.destination, "", "", payload.caseId));
//         dispatch(addMessageHeader(payload.destination, payload.infos));
//         if (payload.destination) {
//           let findChecked = activeheader.find(
//             (header) => header.label === payload.destination,
//           );

//           if (!findChecked) {
//             let storage = JSON.parse(
//               window.localStorage.getItem("switchHeader"),
//             );
//             dispatch(
//               changeActiveHeader(
//                 payload.destination,
//                 typeof storage === "boolean" ? storage : false,
//               ),
//             );
//           }
//         }
//       }

//       if (id === "sendMeLogInteractionDuration") {
//         setTimeout(() => {
//           setCaseId(payload.caseId);
//           setIsSendMe(true);
//           dispatch(
//             changeAtdIngDesk(payload.destination, "", "", payload.caseId),
//           );
//         }, [5000]);
//       }

//       if (id === "getAuditRoute") {
//         iframeRef.current.contentWindow.postMessage(
//           {
//             origin: "ingweb",
//             id: "deliverAuditRoute",
//             url: `${connection_platform.type_connect}://${localStorage.getItem(
//               "pathname",
//             )}:${localStorage.getItem("port")}`,
//           },
//           url_iframe,
//         );
//       }

//       if (id === "deliveryTokenEndPoint") {
//         dispatch(changeTokenIngDeskEndPoint(payload));
//       }

//       if (id === "permissionsIngdesk") {
//         dispatch(editPermissionsIngdesk(payload.permissions));
//       }
//     });

//     dispatch(RegisterRefIframe(iframeRef));
//   }, []);

//   useEffect(() => {
//     if (!idMiddleState) {
//       getIdMiddleware();
//     }

//     if (iframeRef.current !== null && loginIngDesk === false) {
//       setTimeout(() => {
//         try {
//           iframeRef.current.contentWindow.postMessage(
//             { origin: "ingweb", id: "sendingTokenEndPoint" },
//             url_iframe,
//           );
//         } catch (error) {
//           console.log("Error no postmessage", error);
//         }
//       }, [3000]);
//       loginIngDesk = true;
//     }
//   }, [user]);

//   useEffect(() => {
//     if (interaction && interaction.telefone && sendMessage) {
//       let channel = "";

//       if (parseInt(interaction.idmidia) === 1) channel = "Voz";
//       else if (parseInt(interaction.idmidia) === 5) channel = "Whatsapp";
//       else if (parseInt(interaction.idmidia) === 8) channel = "Telegram";

//       let jsonIngDesk = {
//         origin: "ingweb",
//         id: "currentInteraction",
//         payload: {
//           clientId: null,
//           clientName: interaction.cliente,
//           channelId: interaction.idmidia,
//           channelName: channel,
//           destination: interaction.telefone,
//           protocol: interaction.protocolo,
//           interactionId: interaction.serviceatd,
//           isSendLog: true,
//         },
//       };
//       iframeRef.current.contentWindow.postMessage(jsonIngDesk, url_iframe);
//       iframeRef.current.contentWindow.postMessage(
//         {
//           origin: "ingweb",
//           id: "getContactIdInteraction",
//           telefone: interaction.telefone,
//         },
//         url_iframe,
//       );
//     }
//     setSendMessage(false);
//   }, [sendMessage]);

//   useEffect(() => {
//     const effectIngDesk = async () => {
//       if (interactioningdesk.payload && isSendMe && interaction.serviceatd) {
//         let channel = "";

//         if (parseInt(interaction.idmidia) === 1) channel = "Voz";
//         else if (parseInt(interaction.idmidia) === 5) channel = "Whatsapp";
//         else if (parseInt(interaction.idmidia) === 8) channel = "Telegram";

//         if (
//           interaction.idatendimento &&
//           idMiddleware &&
//           caseId &&
//           !isNaN(parseInt(interaction.idatendimento)) &&
//           !isNaN(parseInt(idMiddleware)) &&
//           !isNaN(parseInt(caseId))
//         ) {
//           dispatch(changeAtdIngDesk(interaction.telefone, "", "", caseId));
//           dispatch(
//             changeAtdIngDeskSuccess(interaction.telefone, "", "", caseId),
//           );
//           await insertProtocolCRM(
//             interaction.idatendimento,
//             idMiddleware,
//             caseId,
//           );
//         }

//         let jsonIngDesk = {
//           origin: "ingweb",
//           id: "logInteraction",
//           payload: {
//             caseId: caseId,
//             typeId: parseInt(interaction.idmidia) === 1 ? 1 : 2,
//             typeName: parseInt(interaction.idmidia) === 1 ? "voz" : "chat",
//             clientId: interactioningdesk.payload.clientId,
//             channelId: interaction.idmidia,
//             channelName: channel,
//             interactionId: interaction.serviceatd,
//             externalProtocol: interaction.protocolo,
//             log: {},
//           },
//         };
//         //console.log("LOGINTERACION DEBUGANDO 2", jsonIngDesk)
//         connectionsapi.iframe_ref.current.contentWindow.postMessage(
//           jsonIngDesk,
//           url_iframe,
//         );

//         if (url_iframe !== "") {
//           dispatch(removeInteractionIngDesk());
//         }
//         setIsSendMe(false);
//       }
//     };

//     if (screen.infodisplay !== "NPS") {
//       effectIngDesk();
//     }
//   }, [isSendMe, interactioningdesk]);

//   if (user.ramal) {
//     return (
//       <div style={{ display: "none" }}>
//         <iframe
//           ref={iframeRef}
//           frameBorder="0"
//           src={`${url_iframe}/externo/integracao?login-master=ingenium&login-user=${user.username}&password-master=52e9f8a1500604b372a5c0908d93ee5f`}
//           style={{ height: "100%", width: "100%" }}
//           name="iframe_a"
//           title="Iframe Example"
//           allow="camera;microphone;clipboard-write"
//         ></iframe>
//       </div>
//     );
//   }
//   return <div />;
// };

// export default IngDesk;

// VERSÃO ANTIGA COMENTADA ATÉ VALIDAR ESSA NOVA VERSÃO COM A REGRA DAS LINHAS 811 A 818 - RESTRIÇÃO DE ENVIO DO 'logInteraction' APENAS PARA A TELA DE ATENDIMENTO
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  InsertRegisterNotifier,
  RegisterRefIframe,
  RemoveNotifier,
  ShowInfoDisplay,
  AlterScreen,
  startInteractions,
  changeAtdIngDesk,
  ShowVisibleNextAtd,
  addInteractionIngDesk,
  isSaveInteractionIngDesk,
  isSaveClientIdInteraction,
  removeInteractionIngDesk,
  changeTokenIngDeskEndPoint,
  getmiddlewarecrm,
  insertProtocolCRM,
  changeAtdIngDeskSuccess,
  addMessageHeader,
  changeActiveHeader,
  editPermissionsIngdesk,
  startInteractionsFromClientWallet,
  SolicitarChamadaAtiva,
} from "../actions";
import Moment from "moment";
import { connection_platform } from "../services/api";

let count = 0;
let channelId = 5;
let loginIngDesk = false;
let url_iframe = "";
let idMiddleware = "";
// let caseId = 0;

const IngDesk = () => {
  const iframeRef = useRef(null);
  const dispatch = useDispatch();

  const user = useSelector((state) => state.informationusers);
  const interaction = useSelector((state) => state.atendimento);
  const screen = useSelector((state) => state.infodisplay);
  const interactioningdesk = useSelector((state) => state.interactioningdesk);
  const connectionsapi = useSelector((state) => state.connectionsapi);
  const serviceurl = useSelector((state) => state.serviceurl);
  const activeheader = useSelector((state) => state.activeheader);
  // const routergroups = useSelector((state) => state.routergroups);

  const [sendMessage, setSendMessage] = useState(false);
  const [isSendMe, setIsSendMe] = useState(false);
  const [caseId, setCaseId] = useState(0);
  const [idMiddleState, setIdMiddlestate] = useState(false);

  // console.log("VERIFICANDO A TELA ATUAL DO ING_WEB:", screen)

  if (serviceurl.length !== 0) {
    let ArrayServiceURL = "";

    if (user.nameauth === "IngDesk") {
      ArrayServiceURL = serviceurl.filter((url) => url.typeofcrm === "IngDesk");

      if (ArrayServiceURL.length !== 0) {
        url_iframe = ArrayServiceURL[0].param;
      }
    }
  }

  async function getIdMiddleware() {
    idMiddleware = await getmiddlewarecrm();
    setIdMiddlestate(true);
  }

  // url_iframe = "http://localhost:3000";

  useEffect(() => {
    window.addEventListener("message", (message) => {
      if (message.data.origin !== "ingdesk") return;

      const { id, payload } = message.data;

      if (id === "remindersDeleted") {
        payload.map((todo) => {
          //console.debug("(INGWEB) remindersDeleted - todo: ", todo);
          dispatch(RemoveNotifier(todo.id_tarefas_lembrete));
        });
      }

      if (id === "tasksOverdueDeleted") {
        payload.map((todo) => {
          //console.debug("(INGWEB) tasksOverdueDeleted - todo: ", todo);
          dispatch(RemoveNotifier(todo.idTask));
        });
      }

      if (id === "reminders") {
        let data = Moment();

        payload.map((todo) => {
          // console.debug("(INGWEB) reminders - todo: ", todo);
          dispatch(
            InsertRegisterNotifier(
              [todo.description[0]],
              "mensagemingdesk",
              data,
              "IngDesk",
              todo.mensagem,
              "1",
              todo.idReminder, // notification id
              todo.idReminder,
              todo,
            ),
          );
          count++;
        });
      }

      if (id === "tasksOverdue") {
        let data = Moment();
        payload.map((todo) => {
          //console.debug("(INGWEB) tasksOverdue - todo: ", todo);
          dispatch(
            InsertRegisterNotifier(
              [todo.description[0]],
              "mensagemingdesk",
              data,
              "IngDesk",
              todo.mensagem,
              "1",
              todo.idTask, // notification id
              todo.idTask,
              todo,
            ),
          );
          count++;
        });
      }

      if (id === "caseReminders") {
        let data = Moment();
        payload.map((todo) => {
          // console.debug("(INGWEB) reminders - todo: ", todo);
          dispatch(
            InsertRegisterNotifier(
              [todo.description[0]],
              "mensagemingdesk",
              data,
              "IngDesk",
              todo.mensagem,
              "1",
              todo.idAlert, // notification id
              todo.idCase,
              todo,
            ),
          );
          count++;
        });
      }

      if (id === "startInteraction") {
        dispatch(
          startInteractions(payload.channelId, payload.destination, payload),
        );
        channelId = payload.channelId;
      }

      if (id === "startInteractionFromClientWallet") {
        // dispatch(
        //   startInteractionsFromClientWallet(
        //     payload.channelId,
        //     payload.destination,
        //     payload
        //   )
        // );

        dispatch(
          SolicitarChamadaAtiva(
            // routergroups,
            payload.channelId,
            payload.destination,
          ),
        );

        channelId = payload.channelId;
      }

      if (id === "willLogInteraction") {
        dispatch(
          addInteractionIngDesk({
            ...payload,
            caseId: payload.caseId,
            isSendLog: true,
          }),
        );
      }

      if (id === "saveThisInteraction") {
        dispatch(
          isSaveInteractionIngDesk({ caseId: payload.caseId, isSendLog: true }),
        );
        dispatch(addMessageHeader(payload.destination, payload.infos));

        if (payload.destination) {
          let findChecked = activeheader.find(
            (header) => header.label === payload.destination,
          );

          if (!findChecked) {
            let storage = JSON.parse(
              window.localStorage.getItem("switchHeader"),
            );
            dispatch(
              changeActiveHeader(
                payload.destination,
                typeof storage === "boolean" ? storage : false,
              ),
            );
          }
        }
        setSendMessage(true);
      }

      if (id === "deliveryContactIdInteraction") {
        dispatch(isSaveClientIdInteraction(payload));
      }

      if (id === "sendMeLogInteraction") {
        setCaseId(payload.caseId);
        setIsSendMe(true);
        dispatch(changeAtdIngDesk(payload.destination, "", "", payload.caseId));
        dispatch(addMessageHeader(payload.destination, payload.infos));

        if (payload.destination) {
          let findChecked = activeheader.find(
            (header) => header.label === payload.destination,
          );

          if (!findChecked) {
            let storage = JSON.parse(
              window.localStorage.getItem("switchHeader"),
            );
            dispatch(
              changeActiveHeader(
                payload.destination,
                typeof storage === "boolean" ? storage : false,
              ),
            );
          }
        }
      }

      if (id === "sendMeLogInteractionDuration") {
        setTimeout(() => {
          setCaseId(payload.caseId);
          setIsSendMe(true);
          dispatch(
            changeAtdIngDesk(payload.destination, "", "", payload.caseId),
          );
        }, [5000]);
      }

      if (id === "getAuditRoute") {
        iframeRef.current.contentWindow.postMessage(
          {
            origin: "ingweb",
            id: "deliverAuditRoute",
            url: `${connection_platform.type_connect}://${localStorage.getItem(
              "pathname",
            )}:${localStorage.getItem("port")}`,
          },
          url_iframe,
        );
      }

      if (id === "deliveryTokenEndPoint") {
        dispatch(changeTokenIngDeskEndPoint(payload));
      }

      if (id === "permissionsIngdesk") {
        dispatch(editPermissionsIngdesk(payload.permissions));
      }
    });

    dispatch(RegisterRefIframe(iframeRef));
  }, []);

  useEffect(() => {
    const hasUser = Boolean(user) && (Boolean(user.id) || user.id === 0);
    if (!hasUser) return;
    if (!idMiddleState) {
      getIdMiddleware();
    }

    if (iframeRef.current !== null && loginIngDesk === false) {
      setTimeout(() => {
        try {
          iframeRef.current.contentWindow.postMessage(
            { origin: "ingweb", id: "sendingTokenEndPoint" },
            url_iframe,
          );
        } catch (error) {
          console.log("Error no postmessage", error);
        }
      }, [3000]);
      loginIngDesk = true;
    }
  }, [user]);

  useEffect(() => {
    if (interaction && interaction.telefone && sendMessage) {
      let channel = "";

      if (parseInt(interaction.idmidia) === 1) channel = "Voz";
      else if (parseInt(interaction.idmidia) === 5) channel = "Whatsapp";
      else if (parseInt(interaction.idmidia) === 8) channel = "Telegram";

      let jsonIngDesk = {
        origin: "ingweb",
        id: "currentInteraction",
        payload: {
          clientId: null,
          clientName: interaction.cliente,
          channelId: interaction.idmidia,
          channelName: channel,
          destination: interaction.telefone,
          protocol: interaction.protocolo,
          interactionId: interaction.serviceatd,
          isSendLog: true,
          currentScreen: screen.infodisplay,
        },
      };

      iframeRef.current.contentWindow.postMessage(jsonIngDesk, url_iframe);
      iframeRef.current.contentWindow.postMessage(
        {
          origin: "ingweb",
          id: "getContactIdInteraction",
          telefone: interaction.telefone,
        },
        url_iframe,
      );
    }

    setSendMessage(false);
  }, [sendMessage, screen.infodisplay]);

  useEffect(() => {
    const effectIngDesk = async () => {
      if (interactioningdesk.payload && isSendMe && interaction.serviceatd) {
        let channel = "";

        if (parseInt(interaction.idmidia) === 1) channel = "Voz";
        else if (parseInt(interaction.idmidia) === 5) channel = "Whatsapp";
        else if (parseInt(interaction.idmidia) === 8) channel = "Telegram";

        if (
          interaction.idatendimento &&
          idMiddleware &&
          caseId &&
          !isNaN(parseInt(interaction.idatendimento)) &&
          !isNaN(parseInt(idMiddleware)) &&
          !isNaN(parseInt(caseId))
        ) {
          dispatch(changeAtdIngDesk(interaction.telefone, "", "", caseId));
          dispatch(
            changeAtdIngDeskSuccess(interaction.telefone, "", "", caseId),
          );

          await insertProtocolCRM(
            interaction.idatendimento,
            idMiddleware,
            caseId,
          );
        }

        let jsonIngDesk = {
          origin: "ingweb",
          id: "logInteraction",
          payload: {
            caseId: caseId,
            typeId: parseInt(interaction.idmidia) === 1 ? 1 : 2,
            typeName: parseInt(interaction.idmidia) === 1 ? "voz" : "chat",
            clientId: interactioningdesk.payload.clientId,
            channelId: interaction.idmidia,
            channelName: channel,
            interactionId: interaction.serviceatd,
            externalProtocol: interaction.protocolo,
            log: {},
            currentScreen: screen.infodisplay,
          },
        };

        console.log("LOGINTERACION DEBUGANDO 2", jsonIngDesk);

        // connectionsapi.iframe_ref.current.contentWindow.postMessage(
        //   jsonIngDesk,
        //   url_iframe
        // );

        // NOVA REGRA PARA RESTRINGIR O ENVIO DO 'logInteraction' APENAS PARA A TELA DE ATENDIMENTO - EVITAR ENVIOS DESNECESSÁRIOS PARA AS DEMAIS TELAS
        if (screen.infodisplay === "Clientes") {
          connectionsapi.iframe_ref.current.contentWindow.postMessage(
            jsonIngDesk,
            url_iframe,
          );
        } else {
          console.warn(
            "IngWeb: Envio 'logInteraction' bloqueado. Origem não é a tela de Atendimento.",
          );
        }

        if (url_iframe !== "") {
          dispatch(removeInteractionIngDesk());
        }

        setIsSendMe(false);
      }
    };

    if (screen.infodisplay !== "NPS") {
      effectIngDesk();
    }
  }, [isSendMe, interactioningdesk]);

  if (user.ramal) {
    return (
      <div style={{ display: "none" }}>
        <iframe
          ref={iframeRef}
          frameBorder="0"
          src={`${url_iframe}/externo/integracao?login-master=ingenium&login-user=${user.username}&password-master=52e9f8a1500604b372a5c0908d93ee5f`}
          style={{ height: "100%", width: "100%" }}
          name="iframe_a"
          title="Iframe Example"
          allow="camera;microphone;clipboard-write"
        ></iframe>
      </div>
    );
  }
  return <div />;
};

export default IngDesk;
